<template>
    <b-form-group :label="label + ':'" :description="description" :state="state" class="w-100" :label-cols-lg="labelColsLg" :label-cols-sm="labelColsSm" label-class="fs-14 grey-color fw-700 d-flex align-items-baseline">
        <template #label>
            {{ label }}:
            <div v-if="!!hint" class="atmo-help">
                &nbsp;<i class="atmo-icon-question-mark"></i><span class="atmo-help__text">{{ hint }}</span>
            </div>
        </template>
        <currency-input v-stop-number-mousewheel v-model="text" class="form-control fs-14" currency="RUB" locale="ru" :class="v !== null ? (state ? 'is-valid' : 'is-invalid') : ''" />
        <template v-if="!state">
            <b-form-invalid-feedback force-show>{{ errorMessage }}</b-form-invalid-feedback>
        </template>
    </b-form-group>
</template>

<script>
export default {
    name: 'FormRowEditPrice',
    props: {
        labelColsLg: {
            type: Number,
            default: 3
        },
        labelColsSm: {
            type: Number,
            default: 4
        },
        label: {
            type: String,
            required: true
        },
        description: {
            type: String,
            default: ''
        },
        value: {
            type: Number,
            default: 0
        },
        v: {
            type: Object,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        limit: {
            type: Number,
            default: null
        },
        hint: {
            type: String,
            default: ''
        }
    },
    computed: {
        text: {
            get() {
                return this.value;
            },
            set(value) {
                if (this.v) {
                    this.v.$touch();
                }
                this.$emit('input', value);
            }
        },
        stateClass() {
            if (this.disabled) return null;
            if (this.state === null) return null;
            return this.state ? 'is-valid' : 'is-invalid';
        },
        state() {
            return this.v !== null ? !this.v.$invalid && !this.errorMessage : null;
        },
        errorMessage() {
            if (this.v && !this.v.required && !!this.v.$params.required) return 'Поле обязательно для заполнения';
            if (this.v && !this.v.minValue && !!this.v.$params.minValue) return 'Минимальное значение поля "' + this.label + '" - ' + this.v.$params.minValue.min;
            if (this.v && !this.v.maxValue && !!this.v.$params.maxValue) return  'Поле "' + this.label + '" превышает доступный лимит в ' + this.v.$params.maxValue.max + ' руб.';
            if (this.limit !== null && this.value > this.limit) return 'Поле "' + this.label + '" превышает доступный лимит в ' + this.limit + ' руб.';
            return '';
        }
    }
};
</script>
